function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".number-cart").forEach((el) => {
    el.textContent = count;
  });
}



async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  console.log("Update",text)
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners(){
// Update Quantities
document.querySelectorAll('.cart-drawer__quantity button').forEach((button) => {
  button.addEventListener('click',async() => {
  // Get line item key
  const rootItem = button.parentElement.parentElement.parentElement.parentElement;
  console.log(rootItem)
  const key = rootItem.getAttribute("data-line-item-key");

  // Get new quantity
  const currentQuantity = Number(button.parentElement.querySelector("input").value);

  const isUp = button.classList.contains('cart-drawer__quantity-plus')

  const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1 ;

  console.log({ key, newQuantity})

  //Ajax Update
  const res = await fetch('/cart/update.js',{
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({updates: { [key]: newQuantity }}),
  });
  const cart = await res.json();

  updateCartItemCounts(cart.item_count)
  
  //Update Cart
  updateCartDrawer();
  })


})

document.querySelector(".cart-drawer__container").addEventListener("click",(e) => {
  e.stopPropagation();
})

document
  .querySelectorAll(".cart-drawer__close, .cart-drawer")
  .forEach((el) =>{
    el.addEventListener("click", () => {
      closeCartDrawer()
    });
  });
}





// ✅ EVENT DELEGATION – only attach ONCE
// document.addEventListener("click", async (e) => {
//   // Quantity plus / minus
//   if (e.target.closest(".cart-drawer-quantity-selector button")) {
//     e.preventDefault();

//     const button = e.target.closest("button");
//     const rootItem = button.closest("[data-line-item-key]");
//     const key = rootItem.getAttribute("data-line-item-key");

//     const input = rootItem.querySelector("input");
//     let qty = Number(input.value);

//     if (button.classList.contains("cart-drawer-quantity-selector-plus")) {
//       qty++;
//     } else {
//       qty = Math.max(0, qty - 1);
//     }

//     // Ajax update
//     const res = await fetch("/cart/update.js", {
//       method: "post",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ updates: { [key]: qty } }),
//     });

//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);

//     // Refresh drawer
//     await updateCartDrawer();
//   }

//   // Close drawer (background or X button)
//   if (
//     e.target.closest("cart-drawer__close") ||
//     (e.target.classList.contains("cart-drawer--active") &&
//       !e.target.closest(".cart-drawer--active"))
//   ) {
//     closeCartDrawer();
//   }
// });



// ✅ Ajax add to cart
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    await updateCartDrawer();
    openCartDrawer();
  });
});

// ✅ Prevent default cart link → open drawer
// ✅ Prevent default cart link → open drawer
document.querySelectorAll('a[href="javascript:void(0)"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    
    // Don't open cart drawer if it's the account button
    if (!a.classList.contains('js-call-popup-login')) {
      addCartDrawerListeners();
      openCartDrawer();
    }
  });
});